import { useMaybePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import useMobileLayout from 'Hooks/useMobileLayout';

export function useMobileOrMCLayout() {
  const isMobile = useMobileLayout();
  const maybePageContext = useMaybePageContentContext();
  return isMobile || maybePageContext?.pageContentResource?.type() === 'MissionControl';
}
